// Generado por scripts/update-fiscal-indicators.mjs. No editar a mano.
// INPC: INEGI, series 583766 y 865586. UDI: Banco de México, serie SP68257.

export const INPC_BY_MONTH: Readonly<Record<string, number>> = {
  "1969-01": 0.01159484238536,
  "1969-02": 0.011636457741601,
  "1969-03": 0.011647943020915,
  "1969-04": 0.011679513291063,
  "1969-05": 0.011679513291063,
  "1969-06": 0.011721133828656,
  "1969-07": 0.011765624389987,
  "1969-08": 0.011778544681171,
  "1969-09": 0.011889050989392,
  "1969-10": 0.012013912601418,
  "1969-11": 0.012015347613288,
  "1969-12": 0.012105763749324,
  "1970-01": 0.012197614897229,
  "1970-02": 0.01219617988536,
  "1970-03": 0.01223206037322,
  "1970-04": 0.012247845508294,
  "1970-05": 0.012273680910061,
  "1970-06": 0.012348311911022,
  "1970-07": 0.01240858760818,
  "1970-08": 0.012465993280846,
  "1970-09": 0.012496133719725,
  "1970-10": 0.012500438756085,
  "1970-11": 0.012567894695444,
  "1970-12": 0.012674095966554,
  "1971-01": 0.01279895757858,
  "1971-02": 0.012852058214135,
  "1971-03": 0.012900853812579,
  "1971-04": 0.012966874739317,
  "1971-05": 0.012994145153705,
  "1971-06": 0.013052985838241,
  "1971-07": 0.013042940752149,
  "1971-08": 0.013162057133842,
  "1971-09": 0.013205112683304,
  "1971-10": 0.013218032974488,
  "1971-11": 0.013239558159294,
  "1971-12": 0.013302709061542,
  "1972-01": 0.013361549746078,
  "1972-02": 0.013403170283671,
  "1972-03": 0.013476366272012,
  "1972-04": 0.013561042358315,
  "1972-05": 0.013588307592103,
  "1972-06": 0.013688768814232,
  "1972-07": 0.013740439617765,
  "1972-08": 0.013830855753801,
  "1972-09": 0.013894001475449,
  "1972-10": 0.013904046561542,
  "1972-11": 0.013994462697578,
  "1972-12": 0.014041828464751,
  "1973-01": 0.0142456209335,
  "1973-02": 0.014363307483172,
  "1973-03": 0.014489604107068,
  "1973-04": 0.014719231977583,
  "1973-05": 0.014875669040357,
  "1973-06": 0.014997655446541,
  "1973-07": 0.015382285367961,
  "1973-08": 0.015629138566771,
  "1973-09": 0.016000848196256,
  "1973-10": 0.016206080857473,
  "1973-11": 0.01640557346971,
  "1973-12": 0.01704279145757,
  "1974-01": 0.017652744212393,
  "1974-02": 0.018051724256265,
  "1974-03": 0.018190941171344,
  "1974-04": 0.018437789189555,
  "1974-05": 0.018582746153615,
  "1974-06": 0.018766448450177,
  "1974-07": 0.019037696858285,
  "1974-08": 0.019238624482391,
  "1974-09": 0.019456772254943,
  "1974-10": 0.019842832007633,
  "1974-11": 0.020393944077168,
  "1974-12": 0.020553251164433,
  "1975-01": 0.020815889498317,
  "1975-02": 0.020930700842899,
  "1975-03": 0.021062737516527,
  "1975-04": 0.021240699763357,
  "1975-05": 0.021524868462648,
  "1975-06": 0.021890838043152,
  "1975-07": 0.022065930265491,
  "1975-08": 0.022256812804255,
  "1975-09": 0.022418984735411,
  "1975-10": 0.022533801260593,
  "1975-11": 0.022691673335988,
  "1975-12": 0.02287681064442,
  "1976-01": 0.023318846237755,
  "1976-02": 0.023755141782108,
  "1976-03": 0.023987639677114,
  "1976-04": 0.024155556838602,
  "1976-05": 0.02432490901196,
  "1976-06": 0.024422500208847,
  "1976-07": 0.024629167882685,
  "1976-08": 0.024864535802933,
  "1976-09": 0.025712731681591,
  "1976-10": 0.027160830049132,
  "1976-11": 0.028387910619629,
  "1976-12": 0.02909975960845,
  "1977-01": 0.030026891525182,
  "1977-02": 0.03068994491556,
  "1977-03": 0.031225266669421,
  "1977-04": 0.031697442701635,
  "1977-05": 0.031975866170593,
  "1977-06": 0.032367671152864,
  "1977-07": 0.032733645913967,
  "1977-08": 0.033405309377817,
  "1977-09": 0.033998041984945,
  "1977-10": 0.034257810294339,
  "1977-11": 0.034632389948314,
  "1977-12": 0.03511174104213,
  "1978-01": 0.035892480982932,
  "1978-02": 0.036407712564607,
  "1978-03": 0.036786597255694,
  "1978-04": 0.03719562756626,
  "1978-05": 0.037560162134143,
  "1978-06": 0.038076828728439,
  "1978-07": 0.038722661971122,
  "1978-08": 0.03910872690366,
  "1978-09": 0.039555067534107,
  "1978-10": 0.040034418627922,
  "1978-11": 0.040446313782379,
  "1978-12": 0.040789323166206,
  "1979-01": 0.042237421533746,
  "1979-02": 0.042844504263327,
  "1979-03": 0.043425751591141,
  "1979-04": 0.043814686549672,
  "1979-05": 0.044388763996484,
  "1979-06": 0.044881030200883,
  "1979-07": 0.045424962028217,
  "1979-08": 0.046112415808492,
  "1979-09": 0.046677878001232,
  "1979-10": 0.047493063416521,
  "1979-11": 0.048104451183965,
  "1979-12": 0.048955511907266,
  "1980-01": 0.051342222289501,
  "1980-02": 0.052529117335026,
  "1980-03": 0.053609811109442,
  "1980-04": 0.054546982931667,
  "1980-05": 0.055436799348669,
  "1980-06": 0.056536148282649,
  "1980-07": 0.058114848311197,
  "1980-08": 0.059318963504417,
  "1980-09": 0.059977717037532,
  "1980-10": 0.0608861834335,
  "1980-11": 0.061942481999369,
  "1980-12": 0.063567107601118,
  "1981-01": 0.065615113636637,
  "1981-02": 0.067226824128553,
  "1981-03": 0.06866487222865,
  "1981-04": 0.070213436998918,
  "1981-05": 0.071275470432418,
  "1981-06": 0.07227148812053,
  "1981-07": 0.07354449426498,
  "1981-08": 0.075060048571128,
  "1981-09": 0.076456481314983,
  "1981-10": 0.078152867893203,
  "1981-11": 0.079656936920789,
  "1981-12": 0.081801099141325,
  "1982-01": 0.085865535761614,
  "1982-02": 0.089239653758489,
  "1982-03": 0.092498950048831,
  "1982-04": 0.097512043769908,
  "1982-05": 0.102993008486838,
  "1982-06": 0.107954431404381,
  "1982-07": 0.113517202183875,
  "1982-08": 0.126255878883947,
  "1982-09": 0.132995499622874,
  "1982-10": 0.139890117231354,
  "1982-11": 0.146962697086664,
  "1982-12": 0.162656416386952,
  "1983-01": 0.180355086174049,
  "1983-02": 0.190033959196015,
  "1983-03": 0.199232046112296,
  "1983-04": 0.211845861201845,
  "1983-05": 0.221033903032033,
  "1983-06": 0.22940388942169,
  "1983-07": 0.240746133378659,
  "1983-08": 0.250090607091021,
  "1983-09": 0.257787495004958,
  "1983-10": 0.266341178510578,
  "1983-11": 0.281983237367781,
  "1983-12": 0.294047380580263,
  "1984-01": 0.312727717931516,
  "1984-02": 0.329232317610734,
  "1984-03": 0.343304281333764,
  "1984-04": 0.358155549984224,
  "1984-05": 0.370031685863033,
  "1984-06": 0.38342337604799,
  "1984-07": 0.395992705756055,
  "1984-08": 0.407248838613348,
  "1984-09": 0.41938043776519,
  "1984-10": 0.434033653996634,
  "1984-11": 0.448929413209177,
  "1984-12": 0.46799581549372,
  "1985-01": 0.502711446516467,
  "1985-02": 0.523596221785414,
  "1985-03": 0.543885399603342,
  "1985-04": 0.560621062165695,
  "1985-05": 0.573902240862582,
  "1985-06": 0.588275593431847,
  "1985-07": 0.608762823669541,
  "1985-08": 0.635376851866098,
  "1985-09": 0.660752314213595,
  "1985-10": 0.685852223116624,
  "1985-11": 0.717495124989483,
  "1985-12": 0.766340130588527,
  "1986-01": 0.834092231384849,
  "1986-02": 0.871174477437797,
  "1986-03": 0.911666716794128,
  "1986-04": 0.95926311145802,
  "1986-05": 1.01257009870861,
  "1986-06": 1.07756664433635,
  "1986-07": 1.13133289250856,
  "1986-08": 1.22153124327409,
  "1986-09": 1.29481166937316,
  "1986-10": 1.36882402945339,
  "1986-11": 1.46130432434191,
  "1986-12": 1.57673462586393,
  "1987-01": 1.70440129279554,
  "1987-02": 1.82738639011058,
  "1987-03": 1.94815269938473,
  "1987-04": 2.11860645972715,
  "1987-05": 2.27832505884218,
  "1987-06": 2.4431457328032,
  "1987-07": 2.64102152651602,
  "1987-08": 2.85687154864099,
  "1987-09": 3.04508139480287,
  "1987-10": 3.29884463353191,
  "1987-11": 3.56051142266738,
  "1987-12": 4.08639245860103,
  "1988-01": 4.71824593565043,
  "1988-02": 5.11178304007227,
  "1988-03": 5.37354742558597,
  "1988-04": 5.53894073680059,
  "1988-05": 5.64610868821594,
  "1988-06": 5.76129213653915,
  "1988-07": 5.8574565431644,
  "1988-08": 5.91134334273018,
  "1988-09": 5.94513902207915,
  "1988-10": 5.99048648308192,
  "1988-11": 6.07065434654802,
  "1988-12": 6.19731638571804,
  "1989-01": 6.34902379296307,
  "1989-02": 6.43518354250932,
  "1989-03": 6.50494489882881,
  "1989-04": 6.60222444470371,
  "1989-05": 6.69309876915004,
  "1989-06": 6.77438463671044,
  "1989-07": 6.84214821760472,
  "1989-08": 6.90733277574674,
  "1989-09": 6.97339279500195,
  "1989-10": 7.07652501522327,
  "1989-11": 7.17585543715893,
  "1989-12": 7.4180295787322,
  "1990-01": 7.77603730172787,
  "1990-02": 7.95211985377577,
  "1990-03": 8.09230991966013,
  "1990-04": 8.21547154939074,
  "1990-05": 8.35883767567237,
  "1990-06": 8.54293858947202,
  "1990-07": 8.69873483372649,
  "1990-08": 8.84695044160481,
  "1990-09": 8.9730613687053,
  "1990-10": 9.10205988764724,
  "1990-11": 9.34372310267594,
  "1990-12": 9.63821395386141,
  "1991-01": 9.88387989480137,
  "1991-02": 10.0564247219094,
  "1991-03": 10.1998396437894,
  "1991-04": 10.3066875511982,
  "1991-05": 10.4074416711108,
  "1991-06": 10.5166475834763,
  "1991-07": 10.609584269262,
  "1991-08": 10.6834229773116,
  "1991-09": 10.7898503743119,
  "1991-10": 10.915342738584,
  "1991-11": 11.1863740967847,
  "1991-12": 11.4496798668257,
  "1992-01": 11.6577784653893,
  "1992-02": 11.795900435066,
  "1992-03": 11.9159477202904,
  "1992-04": 12.0221713196406,
  "1992-05": 12.1014378917723,
  "1992-06": 12.1833451921855,
  "1992-07": 12.2602724145201,
  "1992-08": 12.3355922314014,
  "1992-09": 12.4428965245267,
  "1992-10": 12.5324935377915,
  "1992-11": 12.6366203406883,
  "1992-12": 12.8165534814412,
  "1993-01": 12.9773197638673,
  "1993-02": 13.0833453107992,
  "1993-03": 13.1595936894285,
  "1993-04": 13.2354804035143,
  "1993-05": 13.3111374897297,
  "1993-06": 13.3857971232443,
  "1993-07": 13.4501234404208,
  "1993-08": 13.5221121948547,
  "1993-09": 13.6222606722309,
  "1993-10": 13.677973025024,
  "1993-11": 13.7383023563383,
  "1993-12": 13.8430548971257,
  "1994-01": 13.9503749805667,
  "1994-02": 14.022124062044,
  "1994-03": 14.0942247629785,
  "1994-04": 14.1632513049319,
  "1994-05": 14.231682244253,
  "1994-06": 14.3028945689645,
  "1994-07": 14.3663267698675,
  "1994-08": 14.4332866454444,
  "1994-09": 14.5359366445482,
  "1994-10": 14.6122453040552,
  "1994-11": 14.690360856448,
  "1994-12": 14.8192043681591,
  "1995-01": 15.3769909442995,
  "1995-02": 16.0287073487094,
  "1995-03": 16.9736172029501,
  "1995-04": 18.3261332553113,
  "1995-05": 19.0920901909918,
  "1995-06": 19.698024268685,
  "1995-07": 20.099588355294,
  "1995-08": 20.4329812657101,
  "1995-09": 20.8556425301303,
  "1995-10": 21.2847621166146,
  "1995-11": 21.8096083843478,
  "1995-12": 22.5201672711919,
  "1996-01": 23.3297537612935,
  "1996-02": 23.8742620287622,
  "1996-03": 24.3998258803534,
  "1996-04": 25.0934496172036,
  "1996-05": 25.5508423029622,
  "1996-06": 25.9669017285474,
  "1996-07": 26.3360306880634,
  "1996-08": 26.6860717149303,
  "1996-09": 27.1127514903968,
  "1996-10": 27.4511675396208,
  "1996-11": 27.8670834484337,
  "1996-12": 28.7593364537036,
  "1997-01": 29.4988860288599,
  "1997-02": 29.9945980915094,
  "1997-03": 30.3678890736628,
  "1997-04": 30.6959718117285,
  "1997-05": 30.976119445603,
  "1997-06": 31.2509569123077,
  "1997-07": 31.5232110408611,
  "1997-08": 31.8035021966878,
  "1997-09": 32.1996125889942,
  "1997-10": 32.4569408230776,
  "1997-11": 32.8200420108443,
  "1997-12": 33.2798745076214,
  "1998-01": 34.00392411086,
  "1998-02": 34.5992378438525,
  "1998-03": 35.0045333976035,
  "1998-04": 35.3320420634022,
  "1998-05": 35.6134813637621,
  "1998-06": 36.0344204113821,
  "1998-07": 36.3818781104596,
  "1998-08": 36.731632103784,
  "1998-09": 37.3273763870906,
  "1998-10": 37.8622689272582,
  "1998-11": 38.5327862255935,
  "1998-12": 39.4729743246935,
  "1999-01": 40.4697702805404,
  "1999-02": 41.013642812364,
  "1999-03": 41.3946837830669,
  "1999-04": 41.7745766092366,
  "1999-05": 42.0258770767504,
  "1999-06": 42.3020062047591,
  "1999-07": 42.581579771548,
  "1999-08": 42.8212552562384,
  "1999-09": 43.2350183927565,
  "1999-10": 43.508851226519,
  "1999-11": 43.8957764470198,
  "1999-12": 44.335516388566,
  "2000-01": 44.9308301163779,
  "2000-02": 45.3293803145216,
  "2000-03": 45.5806807820354,
  "2000-04": 45.8400182716419,
  "2000-05": 46.0113790737289,
  "2000-06": 46.2839202410061,
  "2000-07": 46.4644662097181,
  "2000-08": 46.7197851882783,
  "2000-09": 47.0610716040147,
  "2000-10": 47.3851358258534,
  "2000-11": 47.7902878628328,
  "2000-12": 48.307671180741,
  "2001-01": 48.5754762479341,
  "2001-02": 48.5433281595649,
  "2001-03": 48.8508877817244,
  "2001-04": 49.0973086323825,
  "2001-05": 49.2099704636254,
  "2001-06": 49.3263637671915,
  "2001-07": 49.1982019640303,
  "2001-08": 49.4896875471858,
  "2001-09": 49.9503811497724,
  "2001-10": 50.1761353677535,
  "2001-11": 50.3651489088722,
  "2001-12": 50.434898785093,
  "2002-01": 50.9004720097159,
  "2002-02": 50.8677498490805,
  "2002-03": 51.1279484444964,
  "2002-04": 51.4072349725615,
  "2002-05": 51.5114292313976,
  "2002-06": 51.7625861769592,
  "2002-07": 51.9111813533618,
  "2002-08": 52.1085603012643,
  "2002-09": 52.4219835649941,
  "2002-10": 52.6530360866857,
  "2002-11": 53.0788772813736,
  "2002-12": 53.3099298030651,
  "2003-01": 53.5254406753155,
  "2003-02": 53.6741224549695,
  "2003-03": 54.0129304127862,
  "2003-04": 54.1051441994704,
  "2003-05": 53.9305596707487,
  "2003-06": 53.9751123991466,
  "2003-07": 54.0533387013335,
  "2003-08": 54.2154899105024,
  "2003-09": 54.5382381638973,
  "2003-10": 54.7382073867067,
  "2003-11": 55.1925416053699,
  "2003-12": 55.4298107868381,
  "2004-01": 55.7743173494501,
  "2004-02": 56.1079447574531,
  "2004-03": 56.2980709356166,
  "2004-04": 56.3830319525618,
  "2004-05": 56.2416029426468,
  "2004-06": 56.3317445094056,
  "2004-07": 56.4793901790965,
  "2004-08": 56.8280411815599,
  "2004-09": 57.2979170496642,
  "2004-10": 57.6947471653946,
  "2004-11": 58.1868993976974,
  "2004-12": 58.3070881533761,
  "2005-01": 58.3091603733014,
  "2005-02": 58.5034309913156,
  "2005-03": 58.7671209768338,
  "2005-04": 58.9764151893082,
  "2005-05": 58.8282514646358,
  "2005-06": 58.771783471666,
  "2005-07": 59.0017998833952,
  "2005-08": 59.0722553608615,
  "2005-09": 59.3090064873482,
  "2005-10": 59.4545799371139,
  "2005-11": 59.8824933517271,
  "2005-12": 60.2503123885007,
  "2006-01": 60.6036258857962,
  "2006-02": 60.6963577274618,
  "2006-03": 60.7725118097234,
  "2006-04": 60.8616172665192,
  "2006-05": 60.5906745112619,
  "2006-06": 60.6429980643804,
  "2006-07": 60.8092937134007,
  "2006-08": 61.1196086472422,
  "2006-09": 61.7366121300559,
  "2006-10": 62.0065187753508,
  "2006-11": 62.3318573036518,
  "2006-12": 62.6924235706863,
  "2007-01": 63.0162079340435,
  "2007-02": 63.1923466277105,
  "2007-03": 63.3291131427925,
  "2007-04": 63.2912951291521,
  "2007-05": 62.9825343602545,
  "2007-06": 63.0581703875346,
  "2007-07": 63.3260048129042,
  "2007-08": 63.5839961936272,
  "2007-09": 64.0777025908746,
  "2007-10": 64.3274050918955,
  "2007-11": 64.7812212555773,
  "2007-12": 65.0490556809461,
  "2008-01": 65.350563680104,
  "2008-02": 65.5448342981189,
  "2008-03": 66.0198907160361,
  "2008-04": 66.1701266606339,
  "2008-05": 66.0986350732053,
  "2008-06": 66.3721681033693,
  "2008-07": 66.7420593600682,
  "2008-08": 67.1274922662089,
  "2008-09": 67.5849348147597,
  "2008-10": 68.0454856931997,
  "2008-11": 68.8189417803872,
  "2008-12": 69.295552363249,
  "2009-01": 69.4561494074742,
  "2009-02": 69.6094936819603,
  "2009-03": 70.0099501825605,
  "2009-04": 70.2549901887493,
  "2009-05": 70.0503584711078,
  "2009-06": 70.1793541614693,
  "2009-07": 70.3705164495951,
  "2009-08": 70.5388843185408,
  "2009-09": 70.8927158708178,
  "2009-10": 71.107190633106,
  "2009-11": 71.4760457798425,
  "2009-12": 71.7718551742052,
  "2010-01": 72.5520459761509,
  "2010-02": 72.9716705110621,
  "2010-03": 73.4897254924342,
  "2010-04": 73.2555646408536,
  "2010-05": 72.7939776524521,
  "2010-06": 72.7711832332712,
  "2010-07": 72.9291900025896,
  "2010-08": 73.1317495003058,
  "2010-09": 73.5151101865211,
  "2010-10": 73.9689263502028,
  "2010-11": 74.5615812488919,
  "2010-12": 74.93095445061,
  "2011-01": 75.2959913456337,
  "2011-02": 75.578460244005,
  "2011-03": 75.7234509285414,
  "2011-04": 75.7174409519803,
  "2011-05": 75.1592643788689,
  "2011-06": 75.1555081435182,
  "2011-07": 75.5161067371837,
  "2011-08": 75.6355550213354,
  "2011-09": 75.8211130476591,
  "2011-10": 76.332712302422,
  "2011-11": 77.1583328325019,
  "2011-12": 77.7923853596971,
  "2012-01": 78.3430494621071,
  "2012-02": 78.502313840976,
  "2012-03": 78.5473886651842,
  "2012-04": 78.3009796261795,
  "2012-05": 78.0538193401046,
  "2012-06": 78.4136666866999,
  "2012-07": 78.8538974697999,
  "2012-08": 79.0905402968928,
  "2012-09": 79.4391189374361,
  "2012-10": 79.8410361199591,
  "2012-11": 80.3834365045976,
  "2012-12": 80.5682432838512,
  "2013-01": 80.8927820181501,
  "2013-02": 81.2909429653224,
  "2013-03": 81.8874331390108,
  "2013-04": 81.9415229280606,
  "2013-05": 81.6688202416011,
  "2013-06": 81.619237934972,
  "2013-07": 81.5921930404471,
  "2013-08": 81.8243283851193,
  "2013-09": 82.1323396838752,
  "2013-10": 82.5229881603462,
  "2013-11": 83.2922651601659,
  "2013-12": 83.7700582967726,
  "2014-01": 84.5190516256987,
  "2014-02": 84.7331570406876,
  "2014-03": 84.9652923853597,
  "2014-04": 84.8067792535609,
  "2014-05": 84.5355790612417,
  "2014-06": 84.6820722399183,
  "2014-07": 84.9149588316606,
  "2014-08": 85.2199651421359,
  "2014-09": 85.5963399242743,
  "2014-10": 86.0696255784602,
  "2014-11": 86.7637778712663,
  "2014-12": 87.1889837129635,
  "2015-01": 87.1101027705992,
  "2015-02": 87.2753771260292,
  "2015-03": 87.6307169902037,
  "2015-04": 87.4038403750225,
  "2015-05": 86.9673658272733,
  "2015-06": 87.1131077588797,
  "2015-07": 87.2408197608029,
  "2015-08": 87.4248752929864,
  "2015-09": 87.7524190155658,
  "2015-10": 88.2039185047178,
  "2015-11": 88.6854678766753,
  "2015-12": 89.0468177174109,
  "2016-01": 89.3863813931126,
  "2016-02": 89.7777811166536,
  "2016-03": 89.9100006009976,
  "2016-04": 89.6252779614159,
  "2016-05": 89.2256145201034,
  "2016-06": 89.3240278862912,
  "2016-07": 89.5569144780335,
  "2016-08": 89.8093334935994,
  "2016-09": 90.357743854799,
  "2016-10": 90.9061542159986,
  "2016-11": 91.6168339443476,
  "2016-12": 92.0390347977643,
  "2017-01": 93.6038824448585,
  "2017-02": 94.1447803353567,
  "2017-03": 94.7224893322916,
  "2017-04": 94.8389326281628,
  "2017-05": 94.7254943205721,
  "2017-06": 94.9636396418054,
  "2017-07": 95.3227357413306,
  "2017-08": 95.7937676543061,
  "2017-09": 96.0935152352906,
  "2017-10": 96.6982691267504,
  "2017-11": 97.6951739888215,
  "2017-12": 98.2728829857563,
  "2018-01": 98.7949996995012,
  "2018-02": 99.1713744816395,
  "2018-03": 99.4921569805878,
  "2018-04": 99.1548470460965,
  "2018-05": 98.9940801730873,
  "2018-06": 99.3764649317868,
  "2018-07": 99.9090991045135,
  "2018-08": 100.492,
  "2018-09": 100.917,
  "2018-10": 101.44,
  "2018-11": 102.303,
  "2018-12": 103.02,
  "2019-01": 103.108,
  "2019-02": 103.079,
  "2019-03": 103.476,
  "2019-04": 103.531,
  "2019-05": 103.233,
  "2019-06": 103.299,
  "2019-07": 103.687,
  "2019-08": 103.67,
  "2019-09": 103.942,
  "2019-10": 104.503,
  "2019-11": 105.346,
  "2019-12": 105.934,
  "2020-01": 106.447,
  "2020-02": 106.889,
  "2020-03": 106.838,
  "2020-04": 105.755,
  "2020-05": 106.162,
  "2020-06": 106.743,
  "2020-07": 107.444,
  "2020-08": 107.867,
  "2020-09": 108.114,
  "2020-10": 108.774,
  "2020-11": 108.856,
  "2020-12": 109.271,
  "2021-01": 110.21,
  "2021-02": 110.907,
  "2021-03": 111.824,
  "2021-04": 112.19,
  "2021-05": 112.419,
  "2021-06": 113.018,
  "2021-07": 113.682,
  "2021-08": 113.899,
  "2021-09": 114.601,
  "2021-10": 115.561,
  "2021-11": 116.884,
  "2021-12": 117.308,
  "2022-01": 118.002,
  "2022-02": 118.981,
  "2022-03": 120.159,
  "2022-04": 120.809,
  "2022-05": 121.022,
  "2022-06": 122.044,
  "2022-07": 122.948,
  "2022-08": 123.803,
  "2022-09": 124.571,
  "2022-10": 125.276,
  "2022-11": 125.997,
  "2022-12": 126.478,
  "2023-01": 127.336,
  "2023-02": 128.046,
  "2023-03": 128.389,
  "2023-04": 128.363,
  "2023-05": 128.084,
  "2023-06": 128.214,
  "2023-07": 128.832,
  "2023-08": 129.545,
  "2023-09": 130.12,
  "2023-10": 130.609,
  "2023-11": 131.445,
  "2023-12": 132.373,
  "2024-01": 133.555,
  "2024-02": 133.681,
  "2024-03": 134.065,
  "2024-04": 134.336,
  "2024-05": 134.087,
  "2024-06": 134.594,
  "2024-07": 136.003,
  "2024-08": 136.013,
  "2024-09": 136.08,
  "2024-10": 136.828,
  "2024-11": 137.424,
  "2024-12": 137.949,
  "2025-01": 138.343,
  "2025-02": 138.726,
  "2025-03": 139.161,
  "2025-04": 139.62,
  "2025-05": 140.012,
  "2025-06": 140.405,
  "2025-07": 140.78,
  "2025-08": 140.867,
  "2025-09": 141.197,
  "2025-10": 141.708,
  "2025-11": 142.645,
  "2025-12": 143.042,
  "2026-01": 143.588,
  "2026-02": 144.307,
  "2026-03": 145.544,
  "2026-04": 145.831,
  "2026-05": 145.527,
  "2026-06": 145.131,
  "2026-07": 145.169
};

export const UDI_BY_DATE: Readonly<Record<string, number>> = {
  "2024-01-01": 7.984185,
  "2024-01-02": 7.98677,
  "2024-01-03": 7.989355,
  "2024-01-04": 7.991941,
  "2024-01-05": 7.994527,
  "2024-01-06": 7.997115,
  "2024-01-07": 7.999703,
  "2024-01-08": 8.002292,
  "2024-01-09": 8.004882,
  "2024-01-10": 8.007473,
  "2024-01-11": 8.010014,
  "2024-01-12": 8.012556,
  "2024-01-13": 8.015099,
  "2024-01-14": 8.017642,
  "2024-01-15": 8.020187,
  "2024-01-16": 8.022732,
  "2024-01-17": 8.025278,
  "2024-01-18": 8.027824,
  "2024-01-19": 8.030372,
  "2024-01-20": 8.03292,
  "2024-01-21": 8.035469,
  "2024-01-22": 8.038019,
  "2024-01-23": 8.04057,
  "2024-01-24": 8.043122,
  "2024-01-25": 8.045674,
  "2024-01-26": 8.048139,
  "2024-01-27": 8.050605,
  "2024-01-28": 8.053072,
  "2024-01-29": 8.05554,
  "2024-01-30": 8.058008,
  "2024-01-31": 8.060477,
  "2024-02-01": 8.062947,
  "2024-02-02": 8.065417,
  "2024-02-03": 8.067888,
  "2024-02-04": 8.07036,
  "2024-02-05": 8.072833,
  "2024-02-06": 8.075307,
  "2024-02-07": 8.077781,
  "2024-02-08": 8.080256,
  "2024-02-09": 8.082732,
  "2024-02-10": 8.085209,
  "2024-02-11": 8.086944,
  "2024-02-12": 8.08868,
  "2024-02-13": 8.090417,
  "2024-02-14": 8.092153,
  "2024-02-15": 8.093891,
  "2024-02-16": 8.095628,
  "2024-02-17": 8.097366,
  "2024-02-18": 8.099104,
  "2024-02-19": 8.100843,
  "2024-02-20": 8.102582,
  "2024-02-21": 8.104321,
  "2024-02-22": 8.106061,
  "2024-02-23": 8.107801,
  "2024-02-24": 8.109541,
  "2024-02-25": 8.111282,
  "2024-02-26": 8.110715,
  "2024-02-27": 8.110147,
  "2024-02-28": 8.109579,
  "2024-02-29": 8.109012,
  "2024-03-01": 8.108444,
  "2024-03-02": 8.107877,
  "2024-03-03": 8.10731,
  "2024-03-04": 8.106742,
  "2024-03-05": 8.106175,
  "2024-03-06": 8.105608,
  "2024-03-07": 8.10504,
  "2024-03-08": 8.104473,
  "2024-03-09": 8.103906,
  "2024-03-10": 8.103339,
  "2024-03-11": 8.103678,
  "2024-03-12": 8.104018,
  "2024-03-13": 8.104357,
  "2024-03-14": 8.104697,
  "2024-03-15": 8.105036,
  "2024-03-16": 8.105376,
  "2024-03-17": 8.105715,
  "2024-03-18": 8.106055,
  "2024-03-19": 8.106395,
  "2024-03-20": 8.106734,
  "2024-03-21": 8.107074,
  "2024-03-22": 8.107413,
  "2024-03-23": 8.107753,
  "2024-03-24": 8.108093,
  "2024-03-25": 8.108432,
  "2024-03-26": 8.109802,
  "2024-03-27": 8.111173,
  "2024-03-28": 8.112543,
  "2024-03-29": 8.113914,
  "2024-03-30": 8.115285,
  "2024-03-31": 8.116657,
  "2024-04-01": 8.118028,
  "2024-04-02": 8.1194,
  "2024-04-03": 8.120772,
  "2024-04-04": 8.122144,
  "2024-04-05": 8.123517,
  "2024-04-06": 8.124889,
  "2024-04-07": 8.126262,
  "2024-04-08": 8.127636,
  "2024-04-09": 8.129009,
  "2024-04-10": 8.130383,
  "2024-04-11": 8.130225,
  "2024-04-12": 8.130067,
  "2024-04-13": 8.12991,
  "2024-04-14": 8.129752,
  "2024-04-15": 8.129594,
  "2024-04-16": 8.129437,
  "2024-04-17": 8.129279,
  "2024-04-18": 8.129121,
  "2024-04-19": 8.128964,
  "2024-04-20": 8.128806,
  "2024-04-21": 8.128648,
  "2024-04-22": 8.128491,
  "2024-04-23": 8.128333,
  "2024-04-24": 8.128175,
  "2024-04-25": 8.128018,
  "2024-04-26": 8.128515,
  "2024-04-27": 8.129012,
  "2024-04-28": 8.129509,
  "2024-04-29": 8.130006,
  "2024-04-30": 8.130503,
  "2024-05-01": 8.131,
  "2024-05-02": 8.131497,
  "2024-05-03": 8.131995,
  "2024-05-04": 8.132492,
  "2024-05-05": 8.132989,
  "2024-05-06": 8.133486,
  "2024-05-07": 8.133984,
  "2024-05-08": 8.134481,
  "2024-05-09": 8.134979,
  "2024-05-10": 8.135476,
  "2024-05-11": 8.136829,
  "2024-05-12": 8.138181,
  "2024-05-13": 8.139535,
  "2024-05-14": 8.140888,
  "2024-05-15": 8.142241,
  "2024-05-16": 8.143595,
  "2024-05-17": 8.144949,
  "2024-05-18": 8.146303,
  "2024-05-19": 8.147658,
  "2024-05-20": 8.149012,
  "2024-05-21": 8.150367,
  "2024-05-22": 8.151722,
  "2024-05-23": 8.153078,
  "2024-05-24": 8.154433,
  "2024-05-25": 8.155789,
  "2024-05-26": 8.154704,
  "2024-05-27": 8.153619,
  "2024-05-28": 8.152535,
  "2024-05-29": 8.15145,
  "2024-05-30": 8.150366,
  "2024-05-31": 8.149281,
  "2024-06-01": 8.148197,
  "2024-06-02": 8.147113,
  "2024-06-03": 8.14603,
  "2024-06-04": 8.144946,
  "2024-06-05": 8.143863,
  "2024-06-06": 8.142779,
  "2024-06-07": 8.141696,
  "2024-06-08": 8.140613,
  "2024-06-09": 8.13953,
  "2024-06-10": 8.138447,
  "2024-06-11": 8.137383,
  "2024-06-12": 8.136319,
  "2024-06-13": 8.135255,
  "2024-06-14": 8.134191,
  "2024-06-15": 8.133128,
  "2024-06-16": 8.132064,
  "2024-06-17": 8.131001,
  "2024-06-18": 8.129938,
  "2024-06-19": 8.128875,
  "2024-06-20": 8.127812,
  "2024-06-21": 8.126749,
  "2024-06-22": 8.125687,
  "2024-06-23": 8.124624,
  "2024-06-24": 8.123562,
  "2024-06-25": 8.1225,
  "2024-06-26": 8.123635,
  "2024-06-27": 8.12477,
  "2024-06-28": 8.125905,
  "2024-06-29": 8.12704,
  "2024-06-30": 8.128175,
  "2024-07-01": 8.129311,
  "2024-07-02": 8.130447,
  "2024-07-03": 8.131583,
  "2024-07-04": 8.132719,
  "2024-07-05": 8.133855,
  "2024-07-06": 8.134991,
  "2024-07-07": 8.136128,
  "2024-07-08": 8.137265,
  "2024-07-09": 8.138402,
  "2024-07-10": 8.139539,
  "2024-07-11": 8.142426,
  "2024-07-12": 8.145314,
  "2024-07-13": 8.148203,
  "2024-07-14": 8.151093,
  "2024-07-15": 8.153985,
  "2024-07-16": 8.156877,
  "2024-07-17": 8.15977,
  "2024-07-18": 8.162665,
  "2024-07-19": 8.16556,
  "2024-07-20": 8.168457,
  "2024-07-21": 8.171354,
  "2024-07-22": 8.174252,
  "2024-07-23": 8.177152,
  "2024-07-24": 8.180052,
  "2024-07-25": 8.182954,
  "2024-07-26": 8.186576,
  "2024-07-27": 8.1902,
  "2024-07-28": 8.193826,
  "2024-07-29": 8.197453,
  "2024-07-30": 8.201082,
  "2024-07-31": 8.204712,
  "2024-08-01": 8.208344,
  "2024-08-02": 8.211977,
  "2024-08-03": 8.215613,
  "2024-08-04": 8.219249,
  "2024-08-05": 8.222888,
  "2024-08-06": 8.226528,
  "2024-08-07": 8.230169,
  "2024-08-08": 8.233813,
  "2024-08-09": 8.237457,
  "2024-08-10": 8.241104,
  "2024-08-11": 8.241847,
  "2024-08-12": 8.242591,
  "2024-08-13": 8.243334,
  "2024-08-14": 8.244078,
  "2024-08-15": 8.244821,
  "2024-08-16": 8.245565,
  "2024-08-17": 8.246309,
  "2024-08-18": 8.247052,
  "2024-08-19": 8.247796,
  "2024-08-20": 8.24854,
  "2024-08-21": 8.249284,
  "2024-08-22": 8.250028,
  "2024-08-23": 8.250772,
  "2024-08-24": 8.251517,
  "2024-08-25": 8.252261,
  "2024-08-26": 8.252113,
  "2024-08-27": 8.251965,
  "2024-08-28": 8.251818,
  "2024-08-29": 8.25167,
  "2024-08-30": 8.251522,
  "2024-08-31": 8.251374,
  "2024-09-01": 8.251226,
  "2024-09-02": 8.251078,
  "2024-09-03": 8.250931,
  "2024-09-04": 8.250783,
  "2024-09-05": 8.250635,
  "2024-09-06": 8.250487,
  "2024-09-07": 8.25034,
  "2024-09-08": 8.250192,
  "2024-09-09": 8.250044,
  "2024-09-10": 8.249896,
  "2024-09-11": 8.249552,
  "2024-09-12": 8.249209,
  "2024-09-13": 8.248865,
  "2024-09-14": 8.248521,
  "2024-09-15": 8.248178,
  "2024-09-16": 8.247834,
  "2024-09-17": 8.247491,
  "2024-09-18": 8.247147,
  "2024-09-19": 8.246803,
  "2024-09-20": 8.24646,
  "2024-09-21": 8.246116,
  "2024-09-22": 8.245773,
  "2024-09-23": 8.245429,
  "2024-09-24": 8.245086,
  "2024-09-25": 8.244742,
  "2024-09-26": 8.245227,
  "2024-09-27": 8.245712,
  "2024-09-28": 8.246197,
  "2024-09-29": 8.246682,
  "2024-09-30": 8.247167,
  "2024-10-01": 8.247652,
  "2024-10-02": 8.248137,
  "2024-10-03": 8.248622,
  "2024-10-04": 8.249107,
  "2024-10-05": 8.249592,
  "2024-10-06": 8.250077,
  "2024-10-07": 8.250563,
  "2024-10-08": 8.251048,
  "2024-10-09": 8.251533,
  "2024-10-10": 8.252018,
  "2024-10-11": 8.251934,
  "2024-10-12": 8.251849,
  "2024-10-13": 8.251764,
  "2024-10-14": 8.251679,
  "2024-10-15": 8.251594,
  "2024-10-16": 8.251509,
  "2024-10-17": 8.251424,
  "2024-10-18": 8.251339,
  "2024-10-19": 8.251254,
  "2024-10-20": 8.251169,
  "2024-10-21": 8.251085,
  "2024-10-22": 8.251,
  "2024-10-23": 8.250915,
  "2024-10-24": 8.25083,
  "2024-10-25": 8.250745,
  "2024-10-26": 8.252935,
  "2024-10-27": 8.255125,
  "2024-10-28": 8.257317,
  "2024-10-29": 8.259508,
  "2024-10-30": 8.2617,
  "2024-10-31": 8.263893,
  "2024-11-01": 8.266087,
  "2024-11-02": 8.268281,
  "2024-11-03": 8.270475,
  "2024-11-04": 8.27267,
  "2024-11-05": 8.274866,
  "2024-11-06": 8.277062,
  "2024-11-07": 8.279259,
  "2024-11-08": 8.281457,
  "2024-11-09": 8.283655,
  "2024-11-10": 8.285853,
  "2024-11-11": 8.287299,
  "2024-11-12": 8.288744,
  "2024-11-13": 8.29019,
  "2024-11-14": 8.291636,
  "2024-11-15": 8.293083,
  "2024-11-16": 8.29453,
  "2024-11-17": 8.295977,
  "2024-11-18": 8.297424,
  "2024-11-19": 8.298871,
  "2024-11-20": 8.300319,
  "2024-11-21": 8.301767,
  "2024-11-22": 8.303215,
  "2024-11-23": 8.304663,
  "2024-11-24": 8.306112,
  "2024-11-25": 8.307561,
  "2024-11-26": 8.309591,
  "2024-11-27": 8.311621,
  "2024-11-28": 8.313652,
  "2024-11-29": 8.315683,
  "2024-11-30": 8.317715,
  "2024-12-01": 8.319748,
  "2024-12-02": 8.32178,
  "2024-12-03": 8.323814,
  "2024-12-04": 8.325848,
  "2024-12-05": 8.327882,
  "2024-12-06": 8.329917,
  "2024-12-07": 8.331952,
  "2024-12-08": 8.333988,
  "2024-12-09": 8.336024,
  "2024-12-10": 8.338061,
  "2024-12-11": 8.337369,
  "2024-12-12": 8.336678,
  "2024-12-13": 8.335986,
  "2024-12-14": 8.335295,
  "2024-12-15": 8.334603,
  "2024-12-16": 8.333912,
  "2024-12-17": 8.333221,
  "2024-12-18": 8.332529,
  "2024-12-19": 8.331838,
  "2024-12-20": 8.331147,
  "2024-12-21": 8.330456,
  "2024-12-22": 8.329765,
  "2024-12-23": 8.329074,
  "2024-12-24": 8.328383,
  "2024-12-25": 8.327692,
  "2024-12-26": 8.329893,
  "2024-12-27": 8.332095,
  "2024-12-28": 8.334298,
  "2024-12-29": 8.336501,
  "2024-12-30": 8.338704,
  "2024-12-31": 8.340909,
  "2025-01-01": 8.343113,
  "2025-01-02": 8.345319,
  "2025-01-03": 8.347525,
  "2025-01-04": 8.349731,
  "2025-01-05": 8.351938,
  "2025-01-06": 8.354146,
  "2025-01-07": 8.356354,
  "2025-01-08": 8.358563,
  "2025-01-09": 8.360772,
  "2025-01-10": 8.362982,
  "2025-01-11": 8.363209,
  "2025-01-12": 8.363435,
  "2025-01-13": 8.363661,
  "2025-01-14": 8.363888,
  "2025-01-15": 8.364114,
  "2025-01-16": 8.36434,
  "2025-01-17": 8.364567,
  "2025-01-18": 8.364793,
  "2025-01-19": 8.36502,
  "2025-01-20": 8.365246,
  "2025-01-21": 8.365472,
  "2025-01-22": 8.365699,
  "2025-01-23": 8.365925,
  "2025-01-24": 8.366152,
  "2025-01-25": 8.366378,
  "2025-01-26": 8.367438,
  "2025-01-27": 8.368498,
  "2025-01-28": 8.369559,
  "2025-01-29": 8.370619,
  "2025-01-30": 8.37168,
  "2025-01-31": 8.372741,
  "2025-02-01": 8.373802,
  "2025-02-02": 8.374863,
  "2025-02-03": 8.375924,
  "2025-02-04": 8.376985,
  "2025-02-05": 8.378047,
  "2025-02-06": 8.379108,
  "2025-02-07": 8.38017,
  "2025-02-08": 8.381232,
  "2025-02-09": 8.382294,
  "2025-02-10": 8.383356,
  "2025-02-11": 8.384051,
  "2025-02-12": 8.384746,
  "2025-02-13": 8.385441,
  "2025-02-14": 8.386136,
  "2025-02-15": 8.386831,
  "2025-02-16": 8.387526,
  "2025-02-17": 8.388222,
  "2025-02-18": 8.388917,
  "2025-02-19": 8.389612,
  "2025-02-20": 8.390308,
  "2025-02-21": 8.391003,
  "2025-02-22": 8.391699,
  "2025-02-23": 8.392394,
  "2025-02-24": 8.39309,
  "2025-02-25": 8.393785,
  "2025-02-26": 8.394727,
  "2025-02-27": 8.395669,
  "2025-02-28": 8.39661,
  "2025-03-01": 8.397552,
  "2025-03-02": 8.398494,
  "2025-03-03": 8.399436,
  "2025-03-04": 8.400379,
  "2025-03-05": 8.401321,
  "2025-03-06": 8.402263,
  "2025-03-07": 8.403206,
  "2025-03-08": 8.404148,
  "2025-03-09": 8.405091,
  "2025-03-10": 8.406034,
  "2025-03-11": 8.406806,
  "2025-03-12": 8.407577,
  "2025-03-13": 8.408349,
  "2025-03-14": 8.409121,
  "2025-03-15": 8.409893,
  "2025-03-16": 8.410665,
  "2025-03-17": 8.411437,
  "2025-03-18": 8.412209,
  "2025-03-19": 8.412981,
  "2025-03-20": 8.413753,
  "2025-03-21": 8.414525,
  "2025-03-22": 8.415298,
  "2025-03-23": 8.41607,
  "2025-03-24": 8.416843,
  "2025-03-25": 8.417615,
  "2025-03-26": 8.418335,
  "2025-03-27": 8.419055,
  "2025-03-28": 8.419774,
  "2025-03-29": 8.420494,
  "2025-03-30": 8.421214,
  "2025-03-31": 8.421934,
  "2025-04-01": 8.422654,
  "2025-04-02": 8.423374,
  "2025-04-03": 8.424094,
  "2025-04-04": 8.424814,
  "2025-04-05": 8.425534,
  "2025-04-06": 8.426255,
  "2025-04-07": 8.426975,
  "2025-04-08": 8.427695,
  "2025-04-09": 8.428416,
  "2025-04-10": 8.429136,
  "2025-04-11": 8.43034,
  "2025-04-12": 8.431543,
  "2025-04-13": 8.432747,
  "2025-04-14": 8.433951,
  "2025-04-15": 8.435155,
  "2025-04-16": 8.436359,
  "2025-04-17": 8.437564,
  "2025-04-18": 8.438769,
  "2025-04-19": 8.439973,
  "2025-04-20": 8.441178,
  "2025-04-21": 8.442383,
  "2025-04-22": 8.443589,
  "2025-04-23": 8.444794,
  "2025-04-24": 8.446,
  "2025-04-25": 8.447206,
  "2025-04-26": 8.447909,
  "2025-04-27": 8.448612,
  "2025-04-28": 8.449315,
  "2025-04-29": 8.450018,
  "2025-04-30": 8.450721,
  "2025-05-01": 8.451424,
  "2025-05-02": 8.452128,
  "2025-05-03": 8.452831,
  "2025-05-04": 8.453535,
  "2025-05-05": 8.454238,
  "2025-05-06": 8.454942,
  "2025-05-07": 8.455645,
  "2025-05-08": 8.456349,
  "2025-05-09": 8.457053,
  "2025-05-10": 8.457756,
  "2025-05-11": 8.458855,
  "2025-05-12": 8.459954,
  "2025-05-13": 8.461053,
  "2025-05-14": 8.462151,
  "2025-05-15": 8.463251,
  "2025-05-16": 8.46435,
  "2025-05-17": 8.465449,
  "2025-05-18": 8.466549,
  "2025-05-19": 8.467648,
  "2025-05-20": 8.468748,
  "2025-05-21": 8.469848,
  "2025-05-22": 8.470948,
  "2025-05-23": 8.472049,
  "2025-05-24": 8.473149,
  "2025-05-25": 8.474249,
  "2025-05-26": 8.474712,
  "2025-05-27": 8.475174,
  "2025-05-28": 8.475636,
  "2025-05-29": 8.476098,
  "2025-05-30": 8.476561,
  "2025-05-31": 8.477023,
  "2025-06-01": 8.477485,
  "2025-06-02": 8.477947,
  "2025-06-03": 8.47841,
  "2025-06-04": 8.478872,
  "2025-06-05": 8.479335,
  "2025-06-06": 8.479797,
  "2025-06-07": 8.48026,
  "2025-06-08": 8.480722,
  "2025-06-09": 8.481185,
  "2025-06-10": 8.481647,
  "2025-06-11": 8.482729,
  "2025-06-12": 8.483812,
  "2025-06-13": 8.484895,
  "2025-06-14": 8.485977,
  "2025-06-15": 8.48706,
  "2025-06-16": 8.488144,
  "2025-06-17": 8.489227,
  "2025-06-18": 8.49031,
  "2025-06-19": 8.491394,
  "2025-06-20": 8.492477,
  "2025-06-21": 8.493561,
  "2025-06-22": 8.494645,
  "2025-06-23": 8.495729,
  "2025-06-24": 8.496813,
  "2025-06-25": 8.497898,
  "2025-06-26": 8.498487,
  "2025-06-27": 8.499077,
  "2025-06-28": 8.499667,
  "2025-06-29": 8.500257,
  "2025-06-30": 8.500847,
  "2025-07-01": 8.501438,
  "2025-07-02": 8.502028,
  "2025-07-03": 8.502618,
  "2025-07-04": 8.503208,
  "2025-07-05": 8.503798,
  "2025-07-06": 8.504389,
  "2025-07-07": 8.504979,
  "2025-07-08": 8.505569,
  "2025-07-09": 8.50616,
  "2025-07-10": 8.50675,
  "2025-07-11": 8.507667,
  "2025-07-12": 8.508584,
  "2025-07-13": 8.509501,
  "2025-07-14": 8.510419,
  "2025-07-15": 8.511336,
  "2025-07-16": 8.512253,
  "2025-07-17": 8.513171,
  "2025-07-18": 8.514089,
  "2025-07-19": 8.515006,
  "2025-07-20": 8.515924,
  "2025-07-21": 8.516842,
  "2025-07-22": 8.51776,
  "2025-07-23": 8.518678,
  "2025-07-24": 8.519596,
  "2025-07-25": 8.520515,
  "2025-07-26": 8.521318,
  "2025-07-27": 8.522121,
  "2025-07-28": 8.522924,
  "2025-07-29": 8.523727,
  "2025-07-30": 8.52453,
  "2025-07-31": 8.525333,
  "2025-08-01": 8.526136,
  "2025-08-02": 8.52694,
  "2025-08-03": 8.527743,
  "2025-08-04": 8.528547,
  "2025-08-05": 8.52935,
  "2025-08-06": 8.530154,
  "2025-08-07": 8.530958,
  "2025-08-08": 8.531762,
  "2025-08-09": 8.532566,
  "2025-08-10": 8.53337,
  "2025-08-11": 8.53377,
  "2025-08-12": 8.53417,
  "2025-08-13": 8.53457,
  "2025-08-14": 8.53497,
  "2025-08-15": 8.53537,
  "2025-08-16": 8.53577,
  "2025-08-17": 8.53617,
  "2025-08-18": 8.536571,
  "2025-08-19": 8.536971,
  "2025-08-20": 8.537371,
  "2025-08-21": 8.537771,
  "2025-08-22": 8.538172,
  "2025-08-23": 8.538572,
  "2025-08-24": 8.538972,
  "2025-08-25": 8.539373,
  "2025-08-26": 8.539259,
  "2025-08-27": 8.539145,
  "2025-08-28": 8.539031,
  "2025-08-29": 8.538918,
  "2025-08-30": 8.538804,
  "2025-08-31": 8.53869,
  "2025-09-01": 8.538577,
  "2025-09-02": 8.538463,
  "2025-09-03": 8.538349,
  "2025-09-04": 8.538236,
  "2025-09-05": 8.538122,
  "2025-09-06": 8.538008,
  "2025-09-07": 8.537895,
  "2025-09-08": 8.537781,
  "2025-09-09": 8.537667,
  "2025-09-10": 8.537553,
  "2025-09-11": 8.538095,
  "2025-09-12": 8.538636,
  "2025-09-13": 8.539178,
  "2025-09-14": 8.539719,
  "2025-09-15": 8.540261,
  "2025-09-16": 8.540803,
  "2025-09-17": 8.541344,
  "2025-09-18": 8.541886,
  "2025-09-19": 8.542428,
  "2025-09-20": 8.542969,
  "2025-09-21": 8.543511,
  "2025-09-22": 8.544053,
  "2025-09-23": 8.544595,
  "2025-09-24": 8.545137,
  "2025-09-25": 8.545679,
  "2025-09-26": 8.546676,
  "2025-09-27": 8.547674,
  "2025-09-28": 8.548672,
  "2025-09-29": 8.54967,
  "2025-09-30": 8.550668,
  "2025-10-01": 8.551666,
  "2025-10-02": 8.552665,
  "2025-10-03": 8.553663,
  "2025-10-04": 8.554662,
  "2025-10-05": 8.555661,
  "2025-10-06": 8.556659,
  "2025-10-07": 8.557658,
  "2025-10-08": 8.558657,
  "2025-10-09": 8.559657,
  "2025-10-10": 8.560656,
  "2025-10-11": 8.560781,
  "2025-10-12": 8.560906,
  "2025-10-13": 8.561032,
  "2025-10-14": 8.561157,
  "2025-10-15": 8.561282,
  "2025-10-16": 8.561408,
  "2025-10-17": 8.561533,
  "2025-10-18": 8.561658,
  "2025-10-19": 8.561784,
  "2025-10-20": 8.561909,
  "2025-10-21": 8.562034,
  "2025-10-22": 8.56216,
  "2025-10-23": 8.562285,
  "2025-10-24": 8.56241,
  "2025-10-25": 8.562536,
  "2025-10-26": 8.564034,
  "2025-10-27": 8.565533,
  "2025-10-28": 8.567033,
  "2025-10-29": 8.568532,
  "2025-10-30": 8.570032,
  "2025-10-31": 8.571532,
  "2025-11-01": 8.573032,
  "2025-11-02": 8.574533,
  "2025-11-03": 8.576034,
  "2025-11-04": 8.577535,
  "2025-11-05": 8.579036,
  "2025-11-06": 8.580538,
  "2025-11-07": 8.58204,
  "2025-11-08": 8.583542,
  "2025-11-09": 8.585045,
  "2025-11-10": 8.586547,
  "2025-11-11": 8.587359,
  "2025-11-12": 8.588171,
  "2025-11-13": 8.588984,
  "2025-11-14": 8.589796,
  "2025-11-15": 8.590608,
  "2025-11-16": 8.59142,
  "2025-11-17": 8.592233,
  "2025-11-18": 8.593045,
  "2025-11-19": 8.593858,
  "2025-11-20": 8.594671,
  "2025-11-21": 8.595483,
  "2025-11-22": 8.596296,
  "2025-11-23": 8.597109,
  "2025-11-24": 8.597922,
  "2025-11-25": 8.598735,
  "2025-11-26": 8.601401,
  "2025-11-27": 8.604069,
  "2025-11-28": 8.606736,
  "2025-11-29": 8.609405,
  "2025-11-30": 8.612075,
  "2025-12-01": 8.614745,
  "2025-12-02": 8.617416,
  "2025-12-03": 8.620088,
  "2025-12-04": 8.622761,
  "2025-12-05": 8.625435,
  "2025-12-06": 8.628109,
  "2025-12-07": 8.630785,
  "2025-12-08": 8.633461,
  "2025-12-09": 8.636138,
  "2025-12-10": 8.638816,
  "2025-12-11": 8.640225,
  "2025-12-12": 8.641634,
  "2025-12-13": 8.643044,
  "2025-12-14": 8.644454,
  "2025-12-15": 8.645864,
  "2025-12-16": 8.647274,
  "2025-12-17": 8.648685,
  "2025-12-18": 8.650096,
  "2025-12-19": 8.651507,
  "2025-12-20": 8.652918,
  "2025-12-21": 8.654329,
  "2025-12-22": 8.655741,
  "2025-12-23": 8.657153,
  "2025-12-24": 8.658565,
  "2025-12-25": 8.659978,
  "2025-12-26": 8.660879,
  "2025-12-27": 8.66178,
  "2025-12-28": 8.662682,
  "2025-12-29": 8.663583,
  "2025-12-30": 8.664485,
  "2025-12-31": 8.665387,
  "2026-01-01": 8.666288,
  "2026-01-02": 8.66719,
  "2026-01-03": 8.668092,
  "2026-01-04": 8.668994,
  "2026-01-05": 8.669897,
  "2026-01-06": 8.670799,
  "2026-01-07": 8.671701,
  "2026-01-08": 8.672604,
  "2026-01-09": 8.673506,
  "2026-01-10": 8.674409,
  "2026-01-11": 8.674288,
  "2026-01-12": 8.674166,
  "2026-01-13": 8.674045,
  "2026-01-14": 8.673924,
  "2026-01-15": 8.673803,
  "2026-01-16": 8.673681,
  "2026-01-17": 8.67356,
  "2026-01-18": 8.673439,
  "2026-01-19": 8.673318,
  "2026-01-20": 8.673196,
  "2026-01-21": 8.673075,
  "2026-01-22": 8.672954,
  "2026-01-23": 8.672832,
  "2026-01-24": 8.672711,
  "2026-01-25": 8.67259,
  "2026-01-26": 8.674251,
  "2026-01-27": 8.675913,
  "2026-01-28": 8.677575,
  "2026-01-29": 8.679237,
  "2026-01-30": 8.6809,
  "2026-01-31": 8.682563,
  "2026-02-01": 8.684226,
  "2026-02-02": 8.685889,
  "2026-02-03": 8.687553,
  "2026-02-04": 8.689217,
  "2026-02-05": 8.690882,
  "2026-02-06": 8.692547,
  "2026-02-07": 8.694212,
  "2026-02-08": 8.695877,
  "2026-02-09": 8.697543,
  "2026-02-10": 8.699209,
  "2026-02-11": 8.700199,
  "2026-02-12": 8.701188,
  "2026-02-13": 8.702178,
  "2026-02-14": 8.703168,
  "2026-02-15": 8.704158,
  "2026-02-16": 8.705148,
  "2026-02-17": 8.706139,
  "2026-02-18": 8.707129,
  "2026-02-19": 8.70812,
  "2026-02-20": 8.70911,
  "2026-02-21": 8.710101,
  "2026-02-22": 8.711092,
  "2026-02-23": 8.712083,
  "2026-02-24": 8.713074,
  "2026-02-25": 8.714065,
  "2026-02-26": 8.71571,
  "2026-02-27": 8.717355,
  "2026-02-28": 8.719,
  "2026-03-01": 8.720645,
  "2026-03-02": 8.722291,
  "2026-03-03": 8.723937,
  "2026-03-04": 8.725584,
  "2026-03-05": 8.727231,
  "2026-03-06": 8.728878,
  "2026-03-07": 8.730525,
  "2026-03-08": 8.732173,
  "2026-03-09": 8.733821,
  "2026-03-10": 8.73547,
  "2026-03-11": 8.737435,
  "2026-03-12": 8.739401,
  "2026-03-13": 8.741367,
  "2026-03-14": 8.743334,
  "2026-03-15": 8.745302,
  "2026-03-16": 8.747269,
  "2026-03-17": 8.749238,
  "2026-03-18": 8.751206,
  "2026-03-19": 8.753175,
  "2026-03-20": 8.755145,
  "2026-03-21": 8.757115,
  "2026-03-22": 8.759085,
  "2026-03-23": 8.761056,
  "2026-03-24": 8.763028,
  "2026-03-25": 8.764999,
  "2026-03-26": 8.768381,
  "2026-03-27": 8.771765,
  "2026-03-28": 8.775149,
  "2026-03-29": 8.778535,
  "2026-03-30": 8.781922,
  "2026-03-31": 8.785311,
  "2026-04-01": 8.788701,
  "2026-04-02": 8.792092,
  "2026-04-03": 8.795484,
  "2026-04-04": 8.798878,
  "2026-04-05": 8.802273,
  "2026-04-06": 8.80567,
  "2026-04-07": 8.809067,
  "2026-04-08": 8.812467,
  "2026-04-09": 8.815867,
  "2026-04-10": 8.819269,
  "2026-04-11": 8.820064,
  "2026-04-12": 8.82086,
  "2026-04-13": 8.821656,
  "2026-04-14": 8.822452,
  "2026-04-15": 8.823248,
  "2026-04-16": 8.824045,
  "2026-04-17": 8.824841,
  "2026-04-18": 8.825637,
  "2026-04-19": 8.826434,
  "2026-04-20": 8.82723,
  "2026-04-21": 8.828027,
  "2026-04-22": 8.828823,
  "2026-04-23": 8.82962,
  "2026-04-24": 8.830417,
  "2026-04-25": 8.831214,
  "2026-04-26": 8.831868,
  "2026-04-27": 8.832523,
  "2026-04-28": 8.833178,
  "2026-04-29": 8.833832,
  "2026-04-30": 8.834487,
  "2026-05-01": 8.835142,
  "2026-05-02": 8.835797,
  "2026-05-03": 8.836451,
  "2026-05-04": 8.837106,
  "2026-05-05": 8.837761,
  "2026-05-06": 8.838416,
  "2026-05-07": 8.839071,
  "2026-05-08": 8.839726,
  "2026-05-09": 8.840382,
  "2026-05-10": 8.841037,
  "2026-05-11": 8.841247,
  "2026-05-12": 8.841457,
  "2026-05-13": 8.841667,
  "2026-05-14": 8.841878,
  "2026-05-15": 8.842088,
  "2026-05-16": 8.842298,
  "2026-05-17": 8.842508,
  "2026-05-18": 8.842718,
  "2026-05-19": 8.842929,
  "2026-05-20": 8.843139,
  "2026-05-21": 8.843349,
  "2026-05-22": 8.843559,
  "2026-05-23": 8.843769,
  "2026-05-24": 8.84398,
  "2026-05-25": 8.84419,
  "2026-05-26": 8.843299,
  "2026-05-27": 8.842407,
  "2026-05-28": 8.841516,
  "2026-05-29": 8.840625,
  "2026-05-30": 8.839734,
  "2026-05-31": 8.838844,
  "2026-06-01": 8.837953,
  "2026-06-02": 8.837062,
  "2026-06-03": 8.836172,
  "2026-06-04": 8.835281,
  "2026-06-05": 8.834391,
  "2026-06-06": 8.833501,
  "2026-06-07": 8.83261,
  "2026-06-08": 8.83172,
  "2026-06-09": 8.83083,
  "2026-06-10": 8.82994,
  "2026-06-11": 8.829172,
  "2026-06-12": 8.828403,
  "2026-06-13": 8.827635,
  "2026-06-14": 8.826867,
  "2026-06-15": 8.826098,
  "2026-06-16": 8.82533,
  "2026-06-17": 8.824562,
  "2026-06-18": 8.823794,
  "2026-06-19": 8.823026,
  "2026-06-20": 8.822258,
  "2026-06-21": 8.82149,
  "2026-06-22": 8.820723,
  "2026-06-23": 8.819955,
  "2026-06-24": 8.819187,
  "2026-06-25": 8.81842,
  "2026-06-26": 8.817781,
  "2026-06-27": 8.817142,
  "2026-06-28": 8.816503,
  "2026-06-29": 8.815864,
  "2026-06-30": 8.815225,
  "2026-07-01": 8.814586,
  "2026-07-02": 8.813947,
  "2026-07-03": 8.813309,
  "2026-07-04": 8.81267,
  "2026-07-05": 8.812031,
  "2026-07-06": 8.811393,
  "2026-07-07": 8.810754,
  "2026-07-08": 8.810116,
  "2026-07-09": 8.809477,
  "2026-07-10": 8.808839,
  "2026-07-11": 8.807682,
  "2026-07-12": 8.806525,
  "2026-07-13": 8.805368,
  "2026-07-14": 8.804211,
  "2026-07-15": 8.803055,
  "2026-07-16": 8.801898,
  "2026-07-17": 8.800742,
  "2026-07-18": 8.799586,
  "2026-07-19": 8.79843,
  "2026-07-20": 8.797274,
  "2026-07-21": 8.796118,
  "2026-07-22": 8.794963,
  "2026-07-23": 8.793807,
  "2026-07-24": 8.792652,
  "2026-07-25": 8.791497,
  "2026-07-26": 8.791887,
  "2026-07-27": 8.792278,
  "2026-07-28": 8.792668,
  "2026-07-29": 8.793058,
  "2026-07-30": 8.793448,
  "2026-07-31": 8.793839,
  "2026-08-01": 8.794229,
  "2026-08-02": 8.794619,
  "2026-08-03": 8.79501,
  "2026-08-04": 8.7954,
  "2026-08-05": 8.795791,
  "2026-08-06": 8.796181,
  "2026-08-07": 8.796571,
  "2026-08-08": 8.796962,
  "2026-08-09": 8.797352,
  "2026-08-10": 8.797743,
  "2026-08-11": 8.798369,
  "2026-08-12": 8.798995,
  "2026-08-13": 8.799622,
  "2026-08-14": 8.800248,
  "2026-08-15": 8.800874,
  "2026-08-16": 8.801501,
  "2026-08-17": 8.802127,
  "2026-08-18": 8.802754,
  "2026-08-19": 8.803381,
  "2026-08-20": 8.804007,
  "2026-08-21": 8.804634,
  "2026-08-22": 8.805261,
  "2026-08-23": 8.805888,
  "2026-08-24": 8.806514,
  "2026-08-25": 8.807141
};

export const FISCAL_INDICATOR_CUTOFFS = {
  inpc: "2026-07",
  udi: "2026-08-25",
} as const;
